import React from 'react';
import classNames from 'classnames';
import { injectStoresV2 } from '../../../stores/injectStoresV2';
import { HeaderStore } from '../../../stores/HeaderStore';
import { WithTranslations, withTranslations } from '../../../../utils/withTranslations';
import { ConfigStore } from '../../../stores/ConfigStore';

import styles from './SearchSubmitButton.scss';

interface SearchButtonProps extends WithTranslations {
  headerStore: HeaderStore;
  dataHook: string;
  configStore: ConfigStore;
}

const SearchSubmitButtonCmp: React.FC<SearchButtonProps> = ({ headerStore, configStore, t, dataHook }) => {
  const isNewUi = configStore.config.newUI;

  return (
    <button
      className={classNames(styles.button, { [styles.newButtonUi]: isNewUi })}
      data-hook={dataHook}
      type="submit"
      tabIndex={-1}
    >
      <span className={styles.text}>{t('search.dropdown.searchFor', { criteria: headerStore.searchCriteria })}</span>
    </button>
  );
};

export const SearchSubmitButton = withTranslations(injectStoresV2('headerStore', 'configStore')(SearchSubmitButtonCmp));
